import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, page: number) =>
  axios.get(
    `${process.env.REACT_APP_API_HOST}/api/messages?page=${page}`,
    config(token)
  );
